<template>
  <div class="calculadora calculadora-imc">
      <div class="row justify-content-center">
          <div class="col-md-4 mb-4">
              <span>
                  <span v-html="strings.description"></span>
              </span>
          </div>
          <form @submit.prevent="calculate()" class="col-md-4">
              <div class="form-group">
                <input @input="showResults = false" id="fld-imc-peso" class="form-control" type="number" min="1" max="500" step="1" v-model="peso" placeholder="Peso, em kilogramas ..." />
                <label for="fld-imc-peso">Seu peso em kg (ex: 80)</label>
              </div>
              <div class="form-group">
                <input @input="showResults = false" id="fld-imc-altura" class="form-control" type="number" min="1" max="250" step="1" v-model="altura" placeholder="Altura, em centímetros ..." />
                <label for="fld-imc-altura">Altura, em cm (ex: 170)</label>
              </div>
              <div class="form-group">
                  <button type="submit" class="btn btn-primary">Calcular</button>
              </div>
          </form>
          <div class="col-md-4">
              <div class="row justify-content-between" v-if="showResults">
                <div class="col-12 mb-2">
                  {{strings.result_title}}: <strong>{{imc.toFixed(1)}} Kg/m²</strong>
                </div>
                  <div class="col-12">
                      <div :class="{'current': faixa === 'very_low'}" v-if="faixa === 'very_low'">
                          <span class="imc-tipo">
                            {{ strings[faixa].title }} <span class="imc-faixa">{{ strings[faixa].range }}</span>
                          </span>
                          <span class="description imc-explicacao">{{strings[faixa].description}}</span>
                      </div>
                      <div :class="{'current': faixa === 'low'}" v-if="faixa === 'low'">
                          <span class="imc-tipo">
                            {{ strings[faixa].title }} <span class="imc-faixa">{{ strings[faixa].range }}</span>
                          </span>
                          <span class="description imc-explicacao">{{strings[faixa].description}}</span>
                      </div>
                      <div :class="{'current': faixa === 'normal'}" v-if="faixa === 'normal'">
                          <span class="imc-tipo">
                            {{ strings[faixa].title }} <span class="imc-faixa">{{ strings[faixa].range }}</span>
                          </span>
                          <span class="description imc-explicacao">{{strings[faixa].description}}</span>
                      </div>
                      <div :class="{'current': faixa === 'high'}" v-if="faixa === 'high'">
                          <span class="imc-tipo">
                            {{ strings[faixa].title }} <span class="imc-faixa">{{ strings[faixa].range }}</span>
                          </span>
                          <span class="description imc-explicacao">{{strings[faixa].description}}</span>
                      </div>
                      <div :class="{'current': faixa === 'obesity'}" v-if="faixa === 'obesity'">
                          <span class="imc-tipo">
                            {{ strings[faixa].title }} <span class="imc-faixa">{{ strings[faixa].range }}</span>
                          </span>
                          <span class="description imc-explicacao">{{strings[faixa].description}}</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
  </div>
</template>
<script>
    export default {

        props: {
            strings: Object
        },
        data: () => { return {
            peso: '',
            altura: '',
            showResults: false,
        }},

      computed: {
        imc: function() {
          return this.peso / ((this.altura / 100) * (this.altura / 100))
        },

        faixa: function() {

          if (this.imc < 17) {
            return 'very_low';
          }

          if (this.imc >= 17 && this.imc < 18.5) {
            return 'low';
          }

          if (this.imc >= 18.5 && this.imc < 25) {
            return 'normal';
          }

          if (this.imc >= 25 && this.imc <= 29.9) {
            return 'high'
          }

          if (this.imc >= 30) {
            return 'obesity'
          }

          return 'obesity';
        }
      },

      methods: {
          calculate: function() {
              this.showResults = true;
          }
      }
    }
</script>
